import React, { useState } from "react";
import { observer } from "mobx-react";

/**
 * One panel per stage, with position dots and a Next that wraps from last to
 * first. This is how a cycle is drawn.
 *
 * Never a ring: radial layouts put every collision rule in polar space, and
 * satellite labels end up overlapping the stages they point at. A wrapping
 * stepper carries the same "returns to the start" meaning with none of that.
 */
const StepperBlock = observer(({ block }) => {
  const [index, setIndex] = useState(0);
  const stages = block.stages || [];
  if (!stages.length) return null;

  const stage = stages[Math.min(index, stages.length - 1)];
  const isLast = index === stages.length - 1;

  return (
    <div className="cpVisual">
      {block.title && <div className="cpVisual__title">{block.title}</div>}
      <div className="cpStepper">
        <div className="cpStepper__head">
          <span className="cpStepper__position">
            {`Step ${index + 1} of ${stages.length}`}
          </span>
          <div className="cpStepper__dots" role="tablist" aria-label="Stages">
            {stages.map((item, dotIndex) => (
              <button
                key={item.title || dotIndex}
                type="button"
                role="tab"
                aria-selected={dotIndex === index}
                aria-label={item.title || `Step ${dotIndex + 1}`}
                className={`cpStepper__dot${dotIndex === index ? " is-active" : ""}`}
                onClick={() => setIndex(dotIndex)}
              />
            ))}
          </div>
        </div>

        <div className="cpStepper__panel">
          <div className="cpStepper__stageTitle">{stage.title}</div>
          {stage.body && <p className="cpStepper__body">{stage.body}</p>}
          {stage.meta && <div className="cpStepper__meta">{stage.meta}</div>}
        </div>

        <div className="cpStepper__actions">
          <button
            type="button"
            className="cpStepper__btn"
            onClick={() => setIndex(i => (i - 1 + stages.length) % stages.length)}
          >
            Previous
          </button>
          <button
            type="button"
            className="cpStepper__btn cpStepper__btn--primary"
            onClick={() => setIndex(i => (i + 1) % stages.length)}
          >
            {/* Wrapping is the point: the label says so at the end. */}
            {isLast ? "Back to start" : "Next"}
          </button>
        </div>
      </div>
    </div>
  );
});

export default StepperBlock;
